import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class XcibilReportGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router){

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isAuthorized = this.authService.getAuthorizationStatus();
    if (!isAuthorized) {
      Swal.fire('Info', 'Please fetch XCIBIL report to view the full report', 'info');
      this.router.navigate(['/api/xcibil-report/search-xcibil']);
      return false;
    }
    return true;
  }
}
